#import "src/queries/fragments/personFragment.graphql"
#import "src/queries/fragments/personManagersTagsFragment.graphql"
#import "src/queries/fragments/personManagerFragment.graphql"
#import "src/queries/fragments/personCardFragment.graphql"
#import "src/queries/fragments/personFilledPositionsFragment.graphql"
#import "src/queries/fragments/accessGroupsFragment.graphql"
#import "src/comments/comments.graphql"
#import "src/pages/TeamDetailPage/teamFragment.graphql"
#import "src/queries/fragments/membershipFragment.graphql"
#import "src/queries/fragments/teamDetailFragment.graphql"

query getPersonWithOptionQuery(
  $aggregateId: String!
  $optionId: ID
  $includePositionFields: Boolean = false
  $includeOverlayAllAttributes: Boolean = false
) {
  person: getPersonWithOption(aggregateId: $aggregateId, optionId: $optionId) {
    ...PersonFragment
    ...PersonManagersTagsFragment
    allAttributes @include(if: $includeOverlayAllAttributes) {
      id
      attributeType
      subtype
      label
      value
    }
    customerEmployeeId
    disabled
    isVacancy
    filledPositions @include(if: $includePositionFields) {
      id
      name
      person {
        aggregateId
        preferredName
        firstName
        surname
        jobTitle
        avatar
        isVacancy
        tags: appliedTags {
          id
          tagId
          type
          displayValue
          isActive
          attributes
        }
        memberOf {
          id
          name
          type
          hierarchy
          hierarchyIds
        }
      }
    }
    memberOf {
      supplyOwners {
        aggregateId
      }
    }
    supplyOwnerOf {
      id
      name
      type
      hierarchy
      hierarchyIds
      parentIds
    }
    managing {
      ...PersonFragment
      ...PersonManagerFragment
      supplyOwnerOf {
        id
        name
        type
        hierarchy
        hierarchyIds
        parentIds
      }
    }
    supplyManaging {
      ...PersonFragment
      ...PersonManagerFragment
      supplyOwnerOf {
        id
        name
        type
        hierarchy
        hierarchyIds
        parentIds
      }
    }
  }
}

# Team page read for an active design option. Same fields as getTeamDetail
# (TeamDetailsFragment); type, isHidden and appliedTags come back overlaid.
query getTeamDetailWithOption($teamId: String!, $optionId: ID) {
  team: getGroupWithOption(groupId: $teamId, optionId: $optionId) {
    ...TeamDetailsFragment
  }
}

# Person page memberships for an active design option. Same fields as
# getPersonMemberships. Option rows carry null startDate/endDate and ignore
# the date filters in $input, so consumers must tolerate null dates.
query getPersonMembershipsWithOption(
  $aggregateId: String!
  $optionId: ID
  $input: SearchMembershipsQuery!
  $includePositionFields: Boolean = false
) {
  person: getPersonWithOption(
    aggregateId: $aggregateId
    optionId: $optionId
    returnWithLegacyProps: false
  ) {
    aggregateId
    fte
    isVacancy
    vacancyId
    permissions {
      canMutateMemberships
    }
    memberships(input: $input) {
      ...MembershipFragment
      position @include(if: $includePositionFields) {
        id
        person {
          aggregateId
          preferredName
          firstName
          surname
          fte
        }
      }
      group {
        ...MembershipGroupFragment
      }
    }
  }
}

# Team associations tab for an active design option. Same fields as
# getTeamAssociationsQuery; associationDirection can be null on added rows.
query getTeamAssociationsWithOption($groupId: String!, $optionId: ID) {
  team: getGroupWithOption(groupId: $groupId, optionId: $optionId) {
    id
    groupAssociations {
      tag {
        id
        tagTypeMetadata {
          name
        }
        type
        displayValue
      }
      group {
        ...TeamDetailFragment
      }
      associationDirection {
        mode
        description
      }
    }
  }
}

# Team header member count for an active design option. Same fields as
# getMemberCount without the position counts.
query getMemberCountWithOption($groupId: String!, $optionId: ID) {
  group: getGroupWithOption(groupId: $groupId, optionId: $optionId) {
    ...TeamMemberCountFragment
  }
}

# Team Insights next-level teams for an active design option. Same selection as
# getChildTeamsInsights. memberCount, directMemberCount, directChildTeamCount,
# name, type and directParentId come back overlaid; parentIds, hierarchy,
# hierarchyIds and isDeleted are trunk values (the option does not rewrite them).
query getChildTeamsInsightsWithOption(
  $teamId: String!
  $comparisonDate: Date
  $optionId: ID
) {
  team: getGroupWithOption(groupId: $teamId, optionId: $optionId) {
    id
    name
    childTeams(comparisonDate: $comparisonDate) {
      id
      name
      type
      directParentId
      parentIds
      hierarchy
      hierarchyIds
      isHidden
      isDeleted
      memberCount
      directMemberCount
      directChildTeamCount
      childTeams(comparisonDate: $comparisonDate) {
        id
        type
        isHidden
        isDeleted
        memberCount
      }
      attributes {
        id
        attributeType
        subtype
        label
        value
      }
    }
  }
}
